import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [caps, setCaps] = useState([]);
  const [capsAll, setCapsAll] = useState(false);
  const [packManage, setPackManage] = useState(false);
  const [committee, setCommittee] = useState(false);
  const [treasurer, setTreasurer] = useState(false);
  const [volunteer, setVolunteer] = useState(false);
  const [loading, setLoading] = useState(true);

  const loadCaps = async () => {
    try {
      const { data } = await api.get("/permissions/me");
      setCaps(data.capabilities || []);
      setCapsAll(!!data.all);
      setPackManage(!!data.pack_manage);
      setCommittee(!!data.committee);
      setTreasurer(!!data.treasurer);
      setVolunteer(!!data.volunteer);
    } catch {
      setCaps([]);
      setCapsAll(false);
      setPackManage(false);
      setCommittee(false);
      setTreasurer(false);
      setVolunteer(false);
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("fp_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then(async (res) => { setUser(res.data); await loadCaps(); })
      .catch(() => localStorage.removeItem("fp_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("fp_token", data.token);
    setUser(data.user);
    await loadCaps();
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("fp_token", data.token);
    setUser(data.user);
    await loadCaps();
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("fp_token");
    setUser(null);
    setCaps([]);
    setCapsAll(false);
    setPackManage(false);
    setCommittee(false);
    setTreasurer(false);
    setVolunteer(false);
  };

  const can = (cap) => capsAll || caps.includes(cap);

  const roles = user ? (user.roles?.length ? user.roles : (user.role ? [user.role] : [])) : [];
  const hasRole = (...rs) => rs.some((r) => roles.includes(r));

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, caps, can, packManage, committee, treasurer, volunteer, roles, hasRole }}>
      {children}
    </AuthContext.Provider>
  );
};
